import { render } from "./Borrador.vue?vue&type=template&id=5429c324"
import script from "./Borrador.vue?vue&type=script&lang=js"
export * from "./Borrador.vue?vue&type=script&lang=js"

import "./Borrador.vue?vue&type=style&index=0&id=5429c324&lang=css"

import exportComponent from "C:\\inetpub\\wwwroot\\login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__